<template>
    <a href="#" v-on:click="copyText()" v-bind:class="[{'animated':animated}, classToSet]" v-on:animationend="animated = false" class="copylink"><clipboard-icon></clipboard-icon></a>
</template>
<script>
    import {ClipboardIcon} from 'vue-feather-icons'

    export default {
        components:{
            ClipboardIcon
        },
        name: 'CopyLink',
        data: function (){
            return {
                animated: false
            }
        },
        props: {
            textToCopy: String,
            classToSet: String
        },
        methods:{
            copyText: function () {
                this.animated = true;
                copyToClipboard(this.textToCopy);
            }
        }
    };
</script>
